import { render, staticRenderFns } from "./DefaultPopup.vue?vue&type=template&id=89e688e4&scoped=true"
import script from "./DefaultPopup.vue?vue&type=script&lang=js"
export * from "./DefaultPopup.vue?vue&type=script&lang=js"
import style0 from "./DefaultPopup.vue?vue&type=style&index=0&id=89e688e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e688e4",
  null
  
)

export default component.exports